import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Menu from '../../components/Menu/Menu';
import useAuth from '../../hooks/useAuth';
import React, { useContext } from 'react';
import './Profile.scss';
import { useEffect, useState } from 'react';
import api from '../../js/api';
import NotAuthenticated from '../../components/NotAuthenticated/NotAuthenticated';
import { UserContext } from '../../js/UserContext';
import { hasRole } from '../../js/utils';


export default function Profile() {
    const navigate = useNavigate();

    const { user, loading } = useContext(UserContext);


    const authenticated = useAuth();
    if (authenticated === false)
        return <NotAuthenticated />;

    const buttons = {
        delete:
            <Button text="Delete Account" onClick={async () => {
                if (!window.confirm('Are you sure you want to delete your account? This action cannot be undone.'))
                    return;

                const response = await api.delete('/users/' + user.login);
                if (!response)
                    return alert('Error deleting account');
                if (response.error)
                    return alert('Error deleting account -> ' + response.error);

                localStorage.removeItem('token');
                api.removeToken();
                navigate('/');
            }} class_="red" />,
        logout:
            <Button text="Log Out" onClick={() => {
                localStorage.removeItem('token');
                api.removeToken();
                window.location.reload();
            }} class_="red white-text" />,
        go_home:
            <Button text="Go Home" onClick={() => {
                navigate('/');
            }} />,
        register_user: hasRole(user, ['tester']) ?
            <Button text="Register User" onClick={() => {
                if (!hasRole(user, ['tester'])) {
                    alert('You do not have permission to register users');
                    return;
                }

                const login = prompt('Enter login for the new user');
                if (!login) {
                    return;
                }

                const password = prompt('Enter password for the new user');
                if (!password) {
                    return;
                }

                const name = prompt('Enter name for the new user (optional)');

                api.post('/user', {
                    login: login,
                    password: password,
                    name: name || null
                }).then((response) => {
                    if (!response || response.error) {
                        alert('Error registering user: ' + (response ? response.error : 'Unknown error'));
                        return;
                    }
                    alert('User registered successfully');
                });
            }} /> : null,
        bigno_challenges:
            <Button text="Bingo Challenges" onClick={() => navigate('/bingo/challenges')} />
    }

    const loadUserData = () => {
        if (loading) {
            return <p>Loading...</p>;
        }
        if (user.error) {
            return <p>{user.error}</p>;
        }
        if (!user) {
            return <p>Error getting user data, try to refresh the page</p>;
        }

        const capitalize = (str) => {
            str = str.replace(/_/g, ' ');
            return str.charAt(0).toUpperCase() + str.slice(1);
        }

        return (
            Object.keys(user).map((data, index) => (
                user[data] ? <p key={index}><b>{capitalize(data)}: </b>{user[data].toString()}</p> : null
            ))
        )
    }

    return (
        <div id="profile">
            <div className="centered-container">
                <h1 className='title'>Profile</h1>
                <div className='user-data-container'>
                    {loadUserData()}
                </div>

                {/* {buttons.delete} */}
                {buttons.logout}
                {buttons.go_home}
                {buttons.register_user}
                <br />
                {/* {buttons.bigno_challenges} */}

                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}